var render, staticRenderFns
import script from "./Organigram.vue?vue&type=script&lang=js"
export * from "./Organigram.vue?vue&type=script&lang=js"
import style0 from "./Organigram.vue?vue&type=style&index=0&id=7c3bd34f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports